<template>
  <div class="progress-statistic">
    <div
      v-for="item in itemsWithProgress"
      :key="item.id"
      class="progress-statistic__item"
    >
      <div
        class="progress-statistic__progress-bar"
        :style="{ width: item.progress + '%', background: item.color }"
      ></div>
      <span
        v-if="typeof item.success_percentage === 'number'"
        class="progress-statistic__progress-count"
      >
        {{ roundNumber(item.success_percentage, 3) }}%
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { roundNumber } from "@/shared/lib/numbers";

const props = defineProps({
  items: Array,
});

const colors = [
  "#6db90c",
  "#f5c828",
  "#f66141",
  "#3697f1",
  "#9747ff",
  "#979797",
];

const itemsWithProgress = computed(() => {
  const maxSuccessCount = Math.max(
    ...props.items.map((item) => item.success_count)
  );

  return props.items.map((item, index) => ({
    ...item,
    progress: (item.success_count / maxSuccessCount) * 100 || 0,
    color: colors[index],
  }));
});
</script>

<style lang="scss">
.progress-statistic {
  &__item {
    position: relative;
    height: var(--Size-common-component-size-small, 24px);
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__progress-bar {
    height: 24px;
    padding-right: 1px;
    line-height: 20px;
    border-radius: var(--Radius-border-radius-base, 4px);
  }
  &__progress-count {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    color: var(--Color-Text-text-color-primary, #303133);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
}
</style>
